import React from 'react';
import PropTypes from 'prop-types';

import Smartcard from '../../../../records/customer/Smartcard';
import CustomerActions from '../../../../actions/CustomerActions';
import KeyGoStore from '../../../../stores/KeyGoStore';
import FeatureFlagStore from '../../../../stores/FeatureFlagStore';
import User from '../../../../records/User';
import KeyGoForm from '../../../../records/customer/KeyGoForm';
import { PaymentUnauthorizedError } from '../../../../errors/Payment';
import { ACTError } from '../../../../errors/Smartcard';

import FormComponent from '../../../form/FormComponent';
import TimeDelayedModal from '../../../general/TimeDelayedModal';
import KeyGoRegistrationWarning from './Warning';

export function getStateFromStores () {
    return {
        form: KeyGoStore.get('form'),
        validation: KeyGoStore.get('validation'),
        error: KeyGoStore.get('error'),
        paymentSucceeded: KeyGoStore.get('paymentSucceeded'),
        enableKeyGoRegistrationWarning: FeatureFlagStore.get('enableKeyGoRegistrationWarning')
    };
}

class KeyGoRegistration extends FormComponent {
    static propTypes = {
        smartcard: PropTypes.instanceOf(Smartcard).isRequired,
        user: PropTypes.instanceOf(User).isRequired,
        isReplacementPending: PropTypes.bool,
        form: PropTypes.instanceOf(KeyGoForm),
        validation: PropTypes.object,
        error: PropTypes.oneOfType([
            PropTypes.instanceOf(PaymentUnauthorizedError),
            PropTypes.instanceOf(ACTError)
        ]),
        paymentSucceeded: PropTypes.bool,
        enableKeyGoRegistrationWarning: PropTypes.bool
    };

    state = {
        loading: false,
        formInvalid: false,
        showRegistrationWarning: false,
        threeDSecureAuthResponse: null,
    };

    checkFormFold = (someCb, noneCb = () => {
        this.setState({ submitted: true, formInvalid: true });
    }) => {
        const { form } = this.props;
        if (form.isComplete()) {
            someCb(form);
        } else {
            noneCb();
        }
    }

    handleKeyGoPay = () => this.checkFormFold(
        () => {
            const { enableKeyGoRegistrationWarning } = this.props;
            // submitted is used by FormComponent to handle scrolling
            this.setState({ submitted: true });

            if (enableKeyGoRegistrationWarning) {
                this.setState({
                    showRegistrationWarning: true,
                });
            } else {
                this.handleRegisterKeyGo();
            }
        }
    );

    handleCloseWarning = () => {
        this.setState({ showRegistrationWarning: false });
    };

    handleConfirmWarning = () => {
        this.handleCloseWarning();
        this.handleRegisterKeyGo();
    };

    handleRegisterKeyGo = () => this.checkFormFold(
        form => {
            this.setState({ threeDSecureAuthResponse: null });
            const { user } = this.props;

            this.setState({ loading: true });
            CustomerActions.registerKeyGo(user, form)
                .then( threeDSecureAuthResponse => {
                    if (threeDSecureAuthResponse) {
                        this.setState({ threeDSecureAuthResponse });
                    }
                })
                .finally(() => this.setState({ loading: false }));
        }
    );

    handleRegisterFinishedKeyGo = async ({ justReset3D } = {}) => {
        if (!justReset3D) {
            CustomerActions.registrationKeyGoFormComplete();
        }

        this.setState({ threeDSecureAuthResponse: null });
    }

    handleFormChange = (...args) => {
        this.setState({ submitted: false, formInvalid: false });
        CustomerActions.changeKeyGoForm(...args);
    };

    handleRetry () {
        CustomerActions.retryKeyGoForm();
    }

    get isButtonDisabled() {
        const { loading, formInvalid} = this.state;

        return loading || formInvalid;
    }

    get keyGoRegistrationProps() {
        const { formInvalid } = this.state;
        const {
            error,
            paymentSucceeded,
            smartcard,
            form,
            validation,
            isReplacementPending,
            user,
        } = this.props;

        return {
            error,
            paymentSucceeded,
            smartcard,
            validation,
            form,
            isReplacementPending,
            formInvalid,
            threeDSecureAuthResponse: this.state.threeDSecureAuthResponse,
            handleFormChange: this.handleFormChange,
            handleRetry: this.handleRetry,
            handleRegisterKeyGo: this.handleRegisterFinishedKeyGo,
            user,
        };
    }

    renderRegistrationWarning () {
        if (!this.state.showRegistrationWarning) {
            return false;
        }
        return (
            <TimeDelayedModal delay={ 10 }
                onClose={ this.handleCloseWarning }
                onContinue={ this.handleConfirmWarning }
                disableClose={ false }
                disableEscape={ false }
                continueText={ 'account.smartcard.keygo.registrationWarning.confirm' }
                closeText='button.text.cancel'
                titleText='account.smartcard.keygo.registrationWarning.title'
                className="modal--med" >
                <KeyGoRegistrationWarning />
            </TimeDelayedModal>
        );

    }
 }


export default KeyGoRegistration;



// WEBPACK FOOTER //
// ./src/components/account/smartcard/keyGoRegistration/AbstractKeyGoRegistration.js